import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    // 登入flag
    auth: 'N',
    transactionId: '',
    userInfo: {},
    callBackParam: '',
};

export const permissions = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
